import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import leaveGuard from '../utils/leaveGuard';

import SignIn from "../views/auth/SignIn.vue";
import PasswordHelp from "../views/auth/PasswordHelp";
import ResetPassword from "../views/auth/ResetPassword.vue";
import Backend from "../views/Backend";
import Trips from "../views/backend/Trips";
import Auswertung from "../views/backend/Auswertung";
import Settings from "../views/backend/Settings";
import SendAlert from "../views/backend/SendAlert";
import Brandings from "../views/backend/Brandings";
import ExtraFeatures from "../views/backend/ExtraFeatures";
import Collections from "../views/backend/Collections";
import POI from "../views/backend/POI";
import editPDF from "../views/backend/editPDF";
import imgKat from "../views/backend/imgKat";
import imgVerwaltung from "../views/backend/imgVerwaltung";
import Modules from "../views/backend/Modules";
import TripsArchived from "../views/backend/TripsArchived";
import Suppliers from "../views/backend/Suppliers";
import SuppliersArchived from "../views/backend/SuppliersArchived";
import ImportRedirect from "../views/backend/ImportRedirect.vue";
import NezasaImportRedirect from "../views/NezasaImportRedirect.vue";
import Passolution from "../views/backend/Passolution.vue";
import Clients from "@/views/backend/Clients";
import Users from "@/views/backend/Users";
import NotFound from "../views/NotFound";
import SuperAdmin from "../views/backend/SuperAdmin";

Vue.use(VueRouter);

let company = process.env.VUE_APP_COMPANY

const routes = [
    {
        path: "/signin",
        name: "signIn",
        meta: {
            title: 'Login | ' + company
        },
        component: SignIn,
        props: true
    },
    {
        path: "/passwordhelp",
        name: "passwordHelp",
        meta: {
            title: 'Need help with your password? | ' + company
        },
        component: PasswordHelp,
        props: true
    },
    {
        path: "/reset-password",
        name: "reset-password",
        meta: {
            title: 'Set new password | ' + company
        },
        component: ResetPassword,
        props: true
    },
    {
        path: "/nezasaimport/:id",
        name: "NezasaImportRedirect",
        meta: {
            title: 'Import Trip | ' + company
        },
        component: NezasaImportRedirect,
        props: true
    },
    {
        path: '/',
        component: Backend,
        name: 'backendHome',
        props: true,
        meta: {
            title: ''
        },
        children: [
            {
                path: "/trips",
                name: "Trips",
                meta: {
                    title: 'Aktive Vorgänge | ' + company
                },
                component: Trips,
                props: true
            },
            {
                path: "/auswertung",
                name: "Auswertung",
                meta: {
                    title: 'Auswertung | ' + company
                },
                component: Auswertung,
                props: true
            },
            {
                path: "/trips_archived",
                name: "TripsArchived",
                meta: {
                    title: 'Archivierte Vorgänge | ' + company
                },
                component: TripsArchived,
                props: true
            },
            {
                path: "/users",
                name: "Users",
                meta: {
                    title: 'Benutzer | ' + company
                },
                component: Users,
                props: true,
            },
            {
                path: "/settings",
                name: "Settings",
                meta: {
                    title: 'Einstellungen | ' + company
                },
                component: Settings,//
                props: true,
            },
            {
                path: "/sendalert",
                name: "SendAlert",
                meta: {
                    title: 'SendAlert | ' + company
                },
                component: SendAlert,//
                props: true,
            },
            {
                path: "/brandings",
                name: "Brandings",
                meta: {
                    title: 'Brandings | ' + company
                },
                component: Brandings,//
                props: true,
            },
            {
                path: "/extra-features",
                name: "ExtraFeatures",
                meta: {
                    title: 'Extra Features | ' + company
                },
                component: ExtraFeatures,
                props: true,
            },
            {
                path: "/collections",
                name: "Collections",
                meta: {
                    title: 'Collections | ' + company
                },
                component: Collections,//
                props: true,
            },
            {
                path: "/pois",
                name: "POI",
                meta: {
                    title: 'POI | ' + company
                },
                component: POI,//
                props: true,
            },
            {
                path: "/editPDF",
                name: "editPDF",
                meta: {
                    title: 'PDF-Kategorien | ' + company
                },
                component: editPDF,//
                props: true,
            },
            {
                path: "/imgKat",
                name: "imgKat",
                meta: {
                    title: 'Titelbilder-Kategorien | ' + company
                },
                component: imgKat,//
                props: true,
            },
            {
                path: "/imgVerwaltung",
                name: "imgVerwaltung",
                meta: {
                    title: 'Titelbilder-Verwaltung | ' + company
                },
                component: imgVerwaltung,//
                props: true,
            },
            {
                path: "/modules",
                name: "Modules",
                meta: {
                    title: 'Modules | ' + company
                },
                component: Modules,//
                props: true,
            },
            {
                path: "/clients",
                name: "Clients",
                meta: {
                    title: 'Mandanten | ' + company
                },
                component: Clients,
                props: true,
            },
            {
              path: "/passolution",
              name: "Passolution",
              meta: {
                title: 'Passolution | ' + company
              },
              component: Passolution,
              props: true,
            },
            {
                path: "/suppliers",
                name: "Suppliers",
                meta: {
                    title: 'Aktive Suppliers | ' + company
                },
                component: Suppliers,
                props: true
            },
            {
                path: "/suppliers_archived",
                name: "SuppliersArchived",
                meta: {
                    title: 'Archivierte Suppliers | ' + company
                },
                component: SuppliersArchived,
                props: true
            },
            {
                path: "/superadmin",
                name: "SuperAdmin",
                meta: {
                    title: 'Super Admin | ' + company
                },
                component: SuperAdmin,
                props: true,
            },
            {
                path: '/import/:id',
                name: 'AutoImportRedirect',
                component: ImportRedirect
            }
        ]
    },
    {path: '/404', component: NotFound},
    {path: '*', redirect: '/404'},
];

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes: routes
});

const PUBLIC_ROUTES = ['signIn', 'passwordHelp', 'reset-password'];

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    const loggedIn = !!store.getters.isLoggedIn;
    if (to.fullPath === '/') {
        return next(loggedIn ? '/trips' : '/signin');
    }
    if (!loggedIn && !PUBLIC_ROUTES.includes(to.name)) {
        return next('/signin');
    }
    // An open form with unsaved changes (e.g. branding editor) asks first.
    leaveGuard.check(next);
});

export default router
